import axios from 'axios'

const moonsOSIncidences = axios.create({
  baseURL: process.env.VUE_APP_MOONS_OS_INCIDENCES_API_URL
})

export {
  moonsOSIncidences
}
